import styles from './HeaderMobile.module.scss';
import { PureHeaderPrimaryLinkBar, PureHeaderSectionLink } from '../types';
import CtaLink, { LinkContext } from 'components/helpers/Atoms/Cta/CtaLink';
import { SvgIcon } from 'components/helpers/SvgIcon';
import useDictionary from 'lib/hooks/useDictionary';
import { generateSubmenuId } from '../Header.utils';
interface HeaderMobileProps {
  primaryLinkBar: PureHeaderPrimaryLinkBar;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  openSubMenu: boolean;
  setOpenSubMenu: (sectionLink?: PureHeaderSectionLink) => void;
  selectedSectionLink: PureHeaderSectionLink | null;
  primaryLinkBarIndex: number;
  linkContext: LinkContext;
}

export const HeaderMobile = (props: HeaderMobileProps) => {
  const { primaryLinkBar, setOpenSubMenu, primaryLinkBarIndex, linkContext } = props;
  const { getDictionaryValue } = useDictionary();
  const showQuickLinks = !primaryLinkBar.hideQuickLinks && primaryLinkBar.quickLinksSection;

  return (
    <>
      {primaryLinkBar?.isNavDropDownMenuLink ? (
        <ul className={styles.menuMobileListDropdown}>
          <li className={styles.menuMobileItemLinkWrapper}>
            <CtaLink
              text={primaryLinkBar?.primaryLinkLabel}
              url={primaryLinkBar?.primaryLinkUrl}
              ctaStyle="none"
              className={styles.menuMobileItemLink}
              target={primaryLinkBar.primaryLinkTarget}
              linkContext={linkContext}
              analyticsHeader={primaryLinkBar?.primaryLinkLabel}
            >
              <span>{primaryLinkBar?.primaryLinkLabel}</span>
              <SvgIcon icon="chevron-right" size="s" />
            </CtaLink>
          </li>
          {primaryLinkBar?.primaryLinks?.map((link, index) => (
            <li key={index} className={styles.menuMobileItemLinkWrapper}>
              <CtaLink
                text={link.headerLinkText}
                url={link.headerLinkUrl}
                ctaStyle="none"
                className={styles.menuMobileItemLink}
                target={link.headerLinkTarget}
                linkContext={linkContext}
                analyticsHeader={primaryLinkBar?.primaryLinkLabel}
              >
                <span>{link.headerLinkText}</span>
                <SvgIcon icon="chevron-right" size="s" />
              </CtaLink>
            </li>
          ))}
        </ul>
      ) : (
        <div className={styles.megaMenuMobileWrapper}>
          {showQuickLinks && (
            <CtaLink
              text={showQuickLinks.quickLinksSectionViewAllTitle}
              url={showQuickLinks.quickLinksSectionViewAllUrl}
              ctaStyle="none"
              className={styles.megaMenuMobileViewAllTextWrapper}
              target={showQuickLinks.quickLinksSectionViewAllTarget}
              linkContext={linkContext}
              analyticsHeader={primaryLinkBar?.primaryLinkLabel}
              analyticsSubHeader={showQuickLinks.quickLinkSectionTitle}
            />
          )}
          {primaryLinkBar?.sectionLinks && primaryLinkBar?.sectionLinks?.length > 0 && (
            <ul className={styles.menuMobileList}>
              {primaryLinkBar.sectionLinks.map((link, index) => {
                if (link.sectionLinkLabel && link.sectionLinkList.length > 0) {
                  return (
                    <li key={index} className={styles.menuMobileItemWrapper}>
                      <button
                        className={styles.menuMobileItemLinkWrapper}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setOpenSubMenu(link);
                        }}
                        aria-controls={generateSubmenuId(link, primaryLinkBarIndex, index)}
                        aria-label={`${getDictionaryValue('Navigation.Header.OpenSubmenuFor') || 'Open submenu for'} ${link.sectionLinkLabel}`}
                      >
                        <span className={styles.menuMobileItemLink}>{link.sectionLinkLabel}</span>
                        {link.sectionLinkLabel &&
                          link.sectionLinkList &&
                          link.sectionLinkList.length > 0 && (
                            <SvgIcon icon="chevron-right" className={styles.menuMobileItemIcon} />
                          )}
                      </button>
                    </li>
                  );
                }
                return (
                  <li key={index} className={styles.menuMobileItemWrapper}>
                    <CtaLink
                      className={styles.menuMobileItemLink}
                      text={link.sectionLinkLabel}
                      url={link.sectionLinkUrl}
                      ctaStyle="none"
                      target={link.sectionLinkTarget}
                      linkContext={linkContext}
                      analyticsHeader={primaryLinkBar?.primaryLinkLabel}
                      analyticsSubHeader={link.sectionLinkLabel}
                    />
                  </li>
                );
              })}
            </ul>
          )}
          {showQuickLinks && showQuickLinks.quickLinkSectionUrls.length > 0 && (
            <div className={styles.quickLinkSectionWrapperMb}>
              <div
                className={styles.quickLinkSectionTitleMb}
                id={`quick-link-section-title-${props.primaryLinkBarIndex}`}
              >
                {showQuickLinks.quickLinkSectionTitle ||
                  getDictionaryValue('Navigation.Header.QuickLinks')}
              </div>
              <ul
                className={styles.quickLinkSectionListMb}
                aria-labelledby={`quick-link-section-title-${props.primaryLinkBarIndex}`}
              >
                {showQuickLinks.quickLinkSectionUrls.map((link, index) => (
                  <li key={index} className={styles.quickLinkSectionItemMb}>
                    <CtaLink
                      text={link.quickLinkSectionLabel}
                      url={link.quickLinkSectionUrl}
                      ctaStyle="none"
                      target={link.quickLinkSectionTarget}
                      linkContext={linkContext}
                      analyticsHeader={primaryLinkBar?.primaryLinkLabel}
                      analyticsSubHeader={showQuickLinks.quickLinkSectionTitle}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </>
  );
};
